const CDN_ORIGIN = 'https://cdn.yuyuankj.cn'
const LEGACY_OSS_ORIGIN = 'https://yuyuan-s.oss-cn-chengdu.aliyuncs.com'

const SIGNED_QUERY_KEYS = new Set([
  'signature', 'expires', 'ossaccesskeyid', 'security-token', 'auth_key'
])

function isSignedUrl(url) {
  for (const key of url.searchParams.keys()) {
    const normalized = key.toLowerCase()
    if (SIGNED_QUERY_KEYS.has(normalized) || normalized.startsWith('x-amz-')
      || (normalized.startsWith('x-oss-') && normalized !== 'x-oss-process')) return true
  }
  return false
}

/** Convert an unsigned legacy OSS public URL to the CDN URL, preserving the raw key. */
export function toPublicMediaUrl(value) {
  if (!value || typeof value !== 'string') return value
  try {
    const url = new URL(value)
    if (url.protocol !== 'https:' || url.hostname.toLowerCase() !== new URL(LEGACY_OSS_ORIGIN).hostname
      || url.port || url.username || url.password || isSignedUrl(url)) return value
    return `${CDN_ORIGIN}${url.pathname}${url.search}${url.hash}`
  } catch (_) {
    return value
  }
}

export { CDN_ORIGIN, LEGACY_OSS_ORIGIN }
